import { render, staticRenderFns } from "./BottomMessage.vue?vue&type=template&id=14768851&scoped=true"
import script from "./BottomMessage.vue?vue&type=script&lang=js"
export * from "./BottomMessage.vue?vue&type=script&lang=js"
import style0 from "./BottomMessage.vue?vue&type=style&index=0&id=14768851&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14768851",
  null
  
)

export default component.exports